import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HISTORY_API_BASE_URL } from '../../api-base-url.token';

@Injectable({ providedIn: 'root' })
export class TradingProcedureReportAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(HISTORY_API_BASE_URL)}/tradingProcedureReportAdmin`;

    getTradingProcedureReport(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getTradingProcedureFlowReport`)
            .get()
            .blob()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .observeResponse()
            .build()
            .send();
    }
}
